import React, { useState, useEffect } from 'react';
import styled from 'styled-components/macro';
import { useCookies } from 'react-cookie';

import { UserAgent } from '@mirinae/js-utils';
import { palette, zIndex } from '@mirinae/react-ui';

import closeXPNG from '@explorer/components/assets/close-x-2.png';
import { cookieDomain, wikinaePaths } from '@mirinae/shared/defines/paths';

const { os } = UserAgent;
const isMobile = !os.isOthers;

const PromoBackground = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    max-height: 100vh;
    display: flex;
    z-index: ${zIndex.tutorial};
    background-color: rgba(0, 0, 0, 0.4);
`;

const WikinaePromoWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    z-index: ${zIndex.tutorial};
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: url(/assets/explorer/mirinae-promo-bg-tile.png) 50%;
    box-shadow: 0 0 15px rgba(196, 196, 196, 0.48);
    border-radius: 20px;
    width: 360px;
    height: 480px;
    pointer-events: none;
  
    & img {
        position: absolute;
        left: 0;
        top: 0;
    }
`;

const CloseX = styled.button`
    position: absolute;
    top: ${isMobile ? '12px' : '20px'};
    right: ${isMobile ? '12px' : '20px'};
    width: 24px;
    height: 24px;
    background: url(${closeXPNG}) no-repeat 50%/cover;
`;

const ShowMeWikinae = styled.a`
    display: flex;
    width: 270px;
    padding: 15px 20px;
    justify-content: center;
    align-items: center;
    border-radius: 25px;
    background: #2D4340;
    margin-top: 342px;
  
    color: #FFF;
    text-align: center;
    font-family: Montserrat;
    font-size: 14px;
    font-weight: 700;

    box-shadow: 0 5px 0 rgba(45, 67, 64, 0.3);

    &:hover {
        box-shadow: none;
        transform: translateY(5px);
        transition: all 0.1s ease-in-out;
    }
`;

const CloseBtn = styled.button`
    color: #2D4340;
    text-align: center;
    font-family: Montserrat;
    font-size: 14px;
    font-weight: 700;
    margin-top: 37px;
`;

const WikinaePromoPopup = ({ isApp }) => {
    const [cookies, setCookie] = useCookies(['wikinaed']);
    const [display, setDisplay] = useState(false);

    const onClose = (e) => {
	    setCookie('wikinaed', 'true', { path: '/', maxAge: 10 * 365 * 24 * 60 * 60, domain: cookieDomain });
        setDisplay(false);
    };

    useEffect(() => {
    	setDisplay(cookies.wikinaed !== 'true' && !cookies.wikinaed);
    }, []);

    return display && (
        <>
            <PromoBackground />
            <WikinaePromoWrapper>
                <img src="/assets/explorer/mirinae-promo.svg" alt="Wikinae!" />
                <CloseX type="button" onClick={onClose} />
                <ShowMeWikinae href={wikinaePaths.home} target="_blank">Check it out!</ShowMeWikinae>
                <CloseBtn onClick={onClose}>Close</CloseBtn>
            </WikinaePromoWrapper>
        </>
    );
};

export default WikinaePromoPopup;
